import { Search } from "lucide-react";
import { Input } from "@ncoder/ui";

export const SidebarSearchBar = ({
  searchTerm,
  setSearchTerm,
  onClick,
  readOnly = false,
}: {
  searchTerm: string;
  setSearchTerm?: (value: string) => void;
  onClick?: () => void;
  readOnly?: boolean;
}) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input
        placeholder={readOnly ? "Click to search files..." : "Search metadata..."}
        value={searchTerm}
        onChange={readOnly ? undefined : (e) => setSearchTerm?.(e.target.value)}
        onClick={onClick}
        readOnly={readOnly}
        className={`pl-10 ${readOnly ? 'cursor-pointer' : ''}`}
      />
    </div>
  );
};
